const Styles = {
    'NoResults': 'NoResults_NoResults--4abd8e45'
};

export default Styles;